module.exports = __webpack_public_path__ + "img/lacasadelasflores.d0b672c0.png";